export const SET_PLANS = "catalogue/SET_PLANS";
export const SET_PRICING_PREFS = "catalogue/SET_PRICING_PREFS";
